var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tort-map-box"},[_c('Row',{staticClass:"filter-box"},[_c('Row',{staticClass:"count-box"},[_vm._v("线索数量："+_vm._s(_vm.clueData?_vm.clueData.length:0))])],1),_vm._v(" "),_c('Row',{staticClass:"map-box"},[_c('div',{attrs:{"id":"tort-map"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0993f18d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/infringementMap/index.vue
// module id = null
// module chunks = 